import React, { useEffect, useState , useRef} from "react";
import SearchIcon from "../../icons/SearchIcon";
import "./styles.scss";

const Search = ({ onSearchEmit, placeholder = "Search", value, style }) => {
  const [inputValue, setInputValue] = useState("");
  const typingTimeoutRef = useRef(null);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);

    // Clear any previously set timeout
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // Set a new timeout to emit the search value
    typingTimeoutRef.current = setTimeout(() => {
      if (newValue?.length >= 1 || newValue === "") {
        onSearchEmit(newValue);
      }
    }, 300); // Trigger after 300ms of inactivity
  };

  return (
    <div className="search" style={style}>
      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text " id="basic-addon1">
            <SearchIcon />
          </span>
        </div>
        <input
          type="text"
          className="form-control"
          placeholder={placeholder}
          style={{ paddingLeft: "0" }}
          aria-label="Username"
          aria-describedby="basic-addon1"
          value={inputValue}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
};

export default Search;
